module.exports = __webpack_public_path__ + "static/media/search-img.24b9bd3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-img.svg
// module id = 921
// module chunks = 0